import { Swal, removeTags } from 'larasnap/support';

const typeOptions = {
    info: {
        icon: 'info',
    },
    success: {
        icon: 'success',
    },
    warning: {
        icon: 'warning',
    },
    error: {
        icon: 'error',
    },
};

export const Message = options => {
    let html = options.message;

    if (removeTags(html).length > 55 && !options.align) {
        options.align = 'left';
    }

    if (options.align === 'left') {
        html = `<div class="text-left">${options.message}</div>`;
    }

    return Swal.fire({
        ...typeOptions[options.type ?? 'info'],
        html,
        ...options,
    });
};

Object.keys(typeOptions).forEach(type => {
    Message[type] = options => Message({ type, ...formatOptions(options) });
});

const formatOptions = options => {
    if (typeof options === 'string') {
        return { message: options };
    } else {
        return options;
    }
};

Message.reportComplete = options => {
    const getButtonHtml = ({ url, icon, label }) => {
        icon = icon ? `<i class="${icon}"></i>` : '';

        return `
            <a href="${url}" target="_blank" class="ml-2 mr-2">
                <button type="button" class="btn btn-default btn-lg">
                    ${icon} ${label}
                </button>
            </a>
        `;
    };

    return Message.success({
        title: 'Report Complete',
        showCloseButton: true,
        showConfirmButton: false,
        allowOutsideClick: false,
        message: `
            <div class="d-flex justify-content-center mt-4 mb-4">
                ${options.buttons.map(getButtonHtml).join('')}
            </div>
        `,
        ...options,
    });
};
